module.exports = {
  account: require('./account'),
  movementRequestStatus: require('./movementRequestStatus'),
  operation: require('./operation')
};
